import { useState } from 'react';

const WHATSAPP_NUMBER = '917795758362';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState('form');
  const [form, setForm] = useState({ name: '', phone: '', email: '', company: '', need: '' });

  const needs = [
    'SuiteCRM Implementation',
    'CRM Customisation',
    'CRM Integration',
    'AI Workflow Automation',
    'Support & Maintenance',
    'General Enquiry',
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim() || !form.email.trim() || !form.need) return;

    setStep('sending');

    if (typeof gtag === 'function') {
      gtag('event', 'whatsapp_form_submit', {
        event_category: 'engagement',
        event_label: form.need,
        company: form.company.trim() || '(not provided)',
      });
    }

    const message = `Hey Aakeeo! 👋

I'm ${form.name.trim()}${form.company.trim() ? ` from ${form.company.trim()}` : ''} and I'd love to chat about *${form.need}*.

Here are my details:
📱 ${form.phone.trim()}
📧 ${form.email.trim()}

Found you on aakeeo.com — looking forward to hearing back!`;

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');

    setTimeout(() => {
      setStep('form');
      setForm({ name: '', phone: '', email: '', company: '', need: '' });
      setIsOpen(false);
    }, 1500);
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => {
          if (!isOpen && typeof gtag === 'function') {
            gtag('event', 'whatsapp_widget_open', { event_category: 'engagement' });
          }
          setIsOpen(!isOpen);
        }}
        aria-label="Chat with us"
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          width: '56px',
          height: '56px',
          borderRadius: '16px',
          background: '#09090b',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
          zIndex: 9999,
          transition: 'transform 0.2s, box-shadow 0.2s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.06)'; e.currentTarget.style.boxShadow = '0 6px 30px rgba(0,0,0,0.25)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.2)'; }}
      >
        {isOpen ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        )}
      </button>

      {/* Panel */}
      {isOpen && (
        <div style={{
          position: 'fixed',
          bottom: '92px',
          right: '24px',
          width: '340px',
          maxWidth: 'calc(100vw - 48px)',
          background: '#fff',
          borderRadius: '20px',
          boxShadow: '0 12px 48px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.04)',
          zIndex: 9998,
          overflow: 'hidden',
          animation: 'wa-slideUp 0.2s ease-out',
        }}>
          <style>{`@keyframes wa-slideUp { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }`}</style>

          {/* Header */}
          <div style={{
            background: '#09090b',
            padding: '22px 20px',
            color: '#fff',
          }}>
            <div style={{ fontWeight: 700, fontSize: '1rem', letterSpacing: '-0.3px' }}>Talk to Aakeeo</div>
            <div style={{ fontSize: '0.8rem', color: '#a1a1aa', marginTop: '4px' }}>We typically reply within an hour</div>
          </div>

          {step === 'form' ? (
            <form onSubmit={handleSubmit} style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <input
                type="text"
                placeholder="Your name *"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
                style={{
                  padding: '11px 14px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '10px',
                  fontSize: '0.9rem',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                }}
                onFocus={(e) => { e.target.style.borderColor = '#09090b'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; }}
              />
              <input
                type="tel"
                placeholder="Phone number *"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                required
                style={{
                  padding: '11px 14px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '10px',
                  fontSize: '0.9rem',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                }}
                onFocus={(e) => { e.target.style.borderColor = '#09090b'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; }}
              />
              <input
                type="email"
                placeholder="Email address *"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                style={{
                  padding: '11px 14px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '10px',
                  fontSize: '0.9rem',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                }}
                onFocus={(e) => { e.target.style.borderColor = '#09090b'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; }}
              />
              <input
                type="text"
                placeholder="Company (optional)"
                value={form.company}
                onChange={(e) => setForm({ ...form, company: e.target.value })}
                style={{
                  padding: '11px 14px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '10px',
                  fontSize: '0.9rem',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                }}
                onFocus={(e) => { e.target.style.borderColor = '#09090b'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; }}
              />
              <select
                value={form.need}
                onChange={(e) => setForm({ ...form, need: e.target.value })}
                required
                style={{
                  padding: '11px 14px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '10px',
                  fontSize: '0.9rem',
                  outline: 'none',
                  background: '#fff',
                  color: form.need ? '#09090b' : '#a0aec0',
                  transition: 'border-color 0.2s',
                  cursor: 'pointer',
                }}
                onFocus={(e) => { e.target.style.borderColor = '#09090b'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; }}
              >
                <option value="" disabled>What do you need help with? *</option>
                {needs.map((n) => (
                  <option key={n} value={n} style={{ color: '#09090b' }}>{n}</option>
                ))}
              </select>
              <button
                type="submit"
                style={{
                  padding: '13px',
                  background: '#09090b',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'background 0.2s',
                  letterSpacing: '-0.2px',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#ff4757'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = '#09090b'; }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
                </svg>
                Continue on WhatsApp
              </button>
            </form>
          ) : (
            <div style={{ padding: '40px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: '1.5rem', marginBottom: '10px' }}>Opening WhatsApp...</div>
              <p style={{ color: '#a1a1aa', fontSize: '0.85rem' }}>You'll be redirected to continue the conversation.</p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default WhatsAppWidget;
